import axios from "axios";
import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../../Loader";


const RejectOrder = (props) => {

  const token = useSelector((state) => state.token);
  const [note, setNote] = useState(null);
  const [loader, setLoader] = useState(false);
  const rejectOrder = () => {
    setLoader(true);
    axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}/order/status/${props.orderId}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      data: JSON.stringify({
        status: "Rejected",
        note: note
      })
    }).then(res => {
      setLoader(false);
      props.getData();
      props.onHide();
      toast(res.data.message, {
        theme: "light",
        position: "top-right",
        type: "success"
      });
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0]?.msg, {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      } else {
        toast(err?.response?.data?.message || err?.message || "Failed to reject order", {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      }
    });
  }

  return (
    <>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="red" closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Reject order
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span>Are you sure you want to reject order?</span>
          <Form.Group className="mb-3" controlId="forName">
            <Form.Label>Enter reject note</Form.Label>
            <Form.Control type="text" value={note} onChange={(t) => { setNote(t.target.value) }} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" className='button red' onClick={() => rejectOrder()}>Reject</Button>
        </Modal.Footer>
      </Modal>
      <Loader show={loader}/>
    </>
  )
}

export default RejectOrder;